import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const notificationLogsRoute: InvariantJiraRoute = {
	name: 'notification-logs',
	path: '/jira/servicedesk/projects/:projectKey/notification-logs',
	exact: true,
};
